import React from "react";
import { motion } from "framer-motion";
import Mouse from "../components/Mouse";
import { pageProjectsData } from "../data/pageProjectsData";

const PageProject9 = () => {
  // Pour afficher seulement les données contenues dans l'ID 9
  // La méthode find() est utilisée pour retourner la première valeur d'un tableau qui satisfait une condition spécifiée dans une fonction de rappel. Elle renvoie undefined si aucun élément du tableau ne satisfait la condition
  const pageProject9Data = pageProjectsData.find((project) => project.id === 9);
  // Pour le cas où il n'y a pas de données pour l'ID 9
  if (!pageProject9Data) {
    return <div>Pas de données pour l'ID 9.</div>;
  }

  const pageProjectAnim = {
    initial: {
      opacity: 0,
      x: Math.floor(Math.random() * 900 * (Math.random() > 0.4 ? 1 : -1)),
      y: Math.floor(Math.random() * 1500 * (Math.random() > 0.4 ? 1 : -1)),
    },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
    },
  };

  const closeWindow = () => {
    window.close();
  };
  return (
    <div>
      <Mouse />
      <div className="page-project">
        <div className="title-page-project">
          <div className="icone hover" onClick={closeWindow}>
            <h3>
              {/* Icône sur le site https://www.toptal.com/designers/htmlarrows/symbols/  */}
              <i className="fa-solid fa-xmark"></i>
            </h3>
          </div>

          <motion.div
            initial="initial"
            animate="visible"
            variants={pageProjectAnim}
            transition={{ duration: 1.2 }}
            // className="img-content"
          >
            <div className="illustrations-container">
              {/* Afficher les données filtrées */}
              <div key={pageProject9Data.id}>
                <h1>{pageProject9Data.title}</h1>
                <p>{pageProject9Data.infos}</p>
                <img src={pageProject9Data.img1} alt="project-img" />
                <img src={pageProject9Data.img2} alt="project-img" />
                <img src={pageProject9Data.img3} alt="project-img" />
                <img src={pageProject9Data.img4} alt="project-img" />
                <img src={pageProject9Data.img5} alt="project-img" />
                <img src={pageProject9Data.img6} alt="project-img" />
                <img src={pageProject9Data.img7} alt="project-img" />
                <img src={pageProject9Data.img8} alt="project-img" />
                <img src={pageProject9Data.img9} alt="project-img" />
                <img src={pageProject9Data.img10} alt="project-img" />
                <img src={pageProject9Data.img11} alt="project-img" />
                <img src={pageProject9Data.img12} alt="project-img" />
                <img src={pageProject9Data.img13} alt="project-img" />
                <img src={pageProject9Data.img14} alt="project-img" />
                <img src={pageProject9Data.img15} alt="project-img" />
                <img src={pageProject9Data.img16} alt="project-img" />
                <img src={pageProject9Data.img17} alt="project-img" />
                <img src={pageProject9Data.img18} alt="project-img" />
                <img src={pageProject9Data.img19} alt="project-img" />
                <img src={pageProject9Data.img20} alt="project-img" />
                <img src={pageProject9Data.img21} alt="project-img" />
                <img src={pageProject9Data.img22} alt="project-img" />
                <img src={pageProject9Data.img23} alt="project-img" />
                <img src={pageProject9Data.img24} alt="project-img" />
                <img src={pageProject9Data.img25} alt="project-img" />
                <img src={pageProject9Data.img26} alt="project-img" />
                <img src={pageProject9Data.img27} alt="project-img" />
                <img src={pageProject9Data.img28} alt="project-img" />
                <img src={pageProject9Data.img29} alt="project-img" />
                <img src={pageProject9Data.img30} alt="project-img" />
                <img src={pageProject9Data.img31} alt="project-img" />
                <img src={pageProject9Data.img32} alt="project-img" />
                <img src={pageProject9Data.img33} alt="project-img" />
                <img src={pageProject9Data.img34} alt="project-img" />
                <img src={pageProject9Data.img35} alt="project-img" />
                <img src={pageProject9Data.img36} alt="project-img" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default PageProject9;
